function padHex(value: number): string {
  const hex = value.toString(16);

  return hex.length < 2 ? '0' + hex : hex;
}

function randomHex(bytes: Uint8Array): string {
  const parts: string[] = [];

  for (let i = 0; i < bytes.length; i += 1) {
    parts.push(padHex(bytes[i]));
  }

  return parts.join('');
}

export function createRequestId(): string {
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const bytes = new Uint8Array(16);

    crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = randomHex(bytes);

    return (
      hex.substr(0, 8) +
      '-' +
      hex.substr(8, 4) +
      '-' +
      hex.substr(12, 4) +
      '-' +
      hex.substr(16, 4) +
      '-' +
      hex.substr(20, 12)
    );
  }

  return (
    'req-' +
    String(Date.now()) +
    '-' +
    Math.random().toString(16).replace('.', '').substr(0, 12)
  );
}
